/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PoolDevice { 
    deviceClassWithOwnIdPool: PoolDevice.DeviceClassWithOwnIdPoolEnum;
    deviceId?: number;
    allocatedToConfigurationId?: string;
}
export namespace PoolDevice {
    export const DeviceClassWithOwnIdPoolEnum = {
        Collar: 'COLLAR',
        ExternalSensor: 'EXTERNAL_SENSOR',
        Camera: 'CAMERA',
        Tt4Sensor: 'TT4_SENSOR',
        ConfigurationDevice: 'CONFIGURATION_DEVICE',
        DropOff: 'DROP_OFF',
        TrapTransmitter: 'TRAP_TRANSMITTER',
        DataLogger: 'DATA_LOGGER'
    } as const;
    export type DeviceClassWithOwnIdPoolEnum = typeof DeviceClassWithOwnIdPoolEnum[keyof typeof DeviceClassWithOwnIdPoolEnum];
}


export type DeviceClassWithOwnIdPoolEnum = typeof PoolDevice.DeviceClassWithOwnIdPoolEnum[keyof typeof PoolDevice.DeviceClassWithOwnIdPoolEnum];
